import $ from 'jquery';
import {MAPBOX_ACCESS_TOKEN} from './mapbox'
import { fromEvent } from 'rxjs';
import { map, filter, debounceTime, distinctUntilChanged, switchMap, finalize } from 'rxjs/operators';

const formPosition = (_options:{
    targetCss?:string,
    cssClassDefault?:string,
    targetForm?:string,
    targetInputLat?:string,
    targetInputLng?:string,
    labelTag?:string,
  }) => {

  const opt = {
    targetCss: '.FormPosition',
    cssClassDefault: 'FormPosition',
    targetForm: '.FormPosition-trueForm',
    targetInputLat: '.FormPosition-lat',
    targetInputLng: '.FormPosition-lng',
    labelTag: 'span',
    labels: {
      label: typeof Drupal !== 'undefined' ? Drupal.t('Adresse / Code postal') : 'Adresse / Code postal',
      locate: typeof Drupal !== 'undefined' ? Drupal.t('Me localiser') : 'Me localiser',
      search: typeof Drupal !== 'undefined' ? Drupal.t('Rechercher') : 'Rechercher',
      placeholder: typeof Drupal !== 'undefined' ? Drupal.t('Ville, Adresse, Code postal...') : 'Ville, Adresse, Code postal...',
      no_result: typeof Drupal !== 'undefined' ? Drupal.t('Aucun resultat pour cette recherche') : 'Aucun resultat pour cette recherche',
      choose_one: typeof Drupal !== 'undefined' ? Drupal.t('Veuillez sélectionner une suggestion') : 'Veuillez sélectionner une suggestion',
      locate_permission_denied: typeof Drupal !== 'undefined' ? Drupal.t('Si vous voulez utiliser cette fonctionnalité vous devez, accepter la géolocalisation du navigateur et rafraichir la page, merci.') : 'Si vous voulez utiliser cette fonctionnalité vous devez, accepter la géolocalisation du navigateur et rafraichir la page, merci.',
      locate_position_unavailable: typeof Drupal !== 'undefined' ? Drupal.t('Ne peux pas récupérer la position actuelle') : 'Ne peux pas récupérer la position actuelle',
      locate_timeout: typeof Drupal !== 'undefined' ? Drupal.t('Délais dépassé pour récupérer la position') : 'Délais dépassé pour récupérer la position',
      unknown_error: typeof Drupal !== 'undefined' ? Drupal.t('Erreur inconnue') : 'Erreur inconnue',
    },
    inputDelay: 200,
    ..._options
  }
  const target = `${opt.targetCss}`
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${opt.cssClassDefault}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${opt.cssClassDefault}`] = true;
    let container = elt;
    if(opt.targetForm === '.views-exposed-form' ) {
      // drupal context
      // create wrapper container
      container = document.createElement('div');
      // insert container before elt in the DOM tree
      elt.parentNode.insertBefore(container, elt);
      // move elt into container
      container.appendChild(elt);
    }

    // declare true fields and form :
    const trueForm = container.querySelector(opt.targetForm);
    const inputLat = container.querySelector(opt.targetInputLat);
    const inputLng = container.querySelector(opt.targetInputLng);
    let formPositionSubmitted:any = sessionStorage.getItem('formPositionSubmitted');
    let userPosition:any = sessionStorage.getItem('userPosition');
    const querySearch = window.location.search;
    if(querySearch !== '') { // get data from query
      const urlParams = new URLSearchParams(querySearch);
      if(urlParams.get('geoloc_lng') !== '') {
        userPosition = {
          latitude: urlParams.get('geoloc_lat'),
          longitude: urlParams.get('geoloc_lng'),
        }
        formPositionSubmitted = urlParams.get('search_address');
      }
    }

    // creat customForm
    const customFormWrapper = document.createElement('div');
    customFormWrapper.classList.add(`${opt.cssClassDefault}-customForm-wrapper`);
    container.appendChild(customFormWrapper);
    const customForm = document.createElement('form');
    customForm.classList.add(`${opt.cssClassDefault}-customForm`);
    customFormWrapper.appendChild(customForm);
    const fieldItem= document.createElement('div');
    fieldItem.classList.add(`${opt.cssClassDefault}-fieldItem`);
    customForm.appendChild(fieldItem);

    const label= document.createElement('label');
    label.classList.add(`${opt.cssClassDefault}-label`);
    label.setAttribute('for', `${opt.cssClassDefault}-input`);

    const labelTagName= document.createElement(opt.labelTag);
    labelTagName.innerHTML = opt.labels.label;
    label.appendChild(labelTagName);
    fieldItem.appendChild(label);

    const inputSearchAddress= document.createElement('input');
    inputSearchAddress.setAttribute('type', 'hidden');
    inputSearchAddress.setAttribute('name', 'search_address');
    trueForm.appendChild(inputSearchAddress);
    const input= document.createElement('input');
    input.classList.add(`${opt.cssClassDefault}-input`);
    input.setAttribute('type', 'text');
    input.setAttribute('placeholder', opt.labels.placeholder);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('id', `${opt.cssClassDefault}-input`);
    if(formPositionSubmitted !== null && userPosition !== null) { // if we come from the previous submit we assign the searched address to input
      input.value = formPositionSubmitted;
      inputSearchAddress.value = formPositionSubmitted;
    }
    fieldItem.appendChild(input);
    const buttonSubmit= document.createElement('button');
    buttonSubmit.classList.add(`${opt.cssClassDefault}-search`);
    buttonSubmit.setAttribute('type', 'submit');
    buttonSubmit.setAttribute('tabindex', '-1'); // avoid focus because button is also not pointable
    buttonSubmit.innerHTML = opt.labels.search;
    customForm.appendChild(buttonSubmit);
    const ajaxLoader= document.createElement('span');
    ajaxLoader.classList.add('AjaxLoader');
    customForm.appendChild(ajaxLoader);
    const dropdown= document.createElement('ul');
    dropdown.classList.add(`${opt.cssClassDefault}-dropdown`);
    fieldItem.appendChild(dropdown);
    const $results = $(dropdown);
    $results.hide();

    let buttonLocate:HTMLButtonElement;

    function searchGeocoding (term:string) {
      customForm.classList.add('isLoading');
      // geocoding url is generated with : https://docs.mapbox.com/search-playground/
      return $.ajax({
        url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(term)}.json`,
        method: 'GET',
        data: {
          access_token: MAPBOX_ACCESS_TOKEN,
          cachebuster: 1588667180707,
          autocomplete: true,
          // list country code available :  france + dom tom => international code based on 2 letters
          // https://www.iban.com/country-codes
          country: 'fr,gp,re,gy,yt,mq,pf,pm,bl,wf,nc,tf',
          types: 'place,address,postcode',
          language: 'fr'
        }
      }).promise();
    }

    const alwaysGeocoding = () => {
      customForm.classList.remove('isLoading');
    }

    const successGeocoding = (data:any) => {
      alwaysGeocoding();
      $results.empty().append(data.features.length > 0 ?
        // results for the request
        data.features.map((feature:any) => {
          const li = document.createElement('li');
          li.innerHTML = feature.place_name;
          li.classList.add(`${opt.cssClassDefault}-dropdown-item`);
          li.addEventListener('click', (_event) => {
            $results.hide().find(`.${opt.cssClassDefault}-dropdown-item--error`).remove();
            inputLat.value = feature.center[1];
            inputLng.value = feature.center[0];
            input.value = feature.place_name;
            inputSearchAddress.value = feature.place_name;
            customFormSubmit();
          });
          return $(li);
        }) :
        // no results for the request
        () => {
          const li = document.createElement('li');
          li.classList.add(`${opt.cssClassDefault}-dropdown-item`);
          li.classList.add(`${opt.cssClassDefault}-dropdown-item--error`);
          li.innerHTML = opt.labels.no_result;
          return $(li);
        }
      )
      .show();
    };

    const errorGeocoding = (error:any) => {
      alwaysGeocoding();
      const li = document.createElement('li');
      li.classList.add(`${opt.cssClassDefault}-dropdown-item`);
      li.classList.add(`${opt.cssClassDefault}-dropdown-item--error`);
      li.innerHTML = error.responseText;
      $results.empty().append($(li)).show();
    };

    const clearValues = () => {
      inputLat.value = '';
      inputLng.value = '';
      sessionStorage.removeItem('userPosition');
    };

    input.addEventListener('focus', (_event) => {
      if($results.find('li').length) {
        $results.show();
      }
    });
    window.addEventListener('click', (event) => {
      if (!fieldItem.contains(event.target as HTMLElement) && event.target !== fieldItem ){
        // Clicked outside the fieldItem
        $results.hide();
      }
    });

    input.addEventListener('input', (event) => {
      // always clear value on input (must be selected by dropdown)
      clearValues();
      if((event.target as HTMLInputElement).value.length <= 2) {
        $results.hide().empty();
      }
    });
    // Get all distinct key up events from the input and only fire if long enough and distinct
    const obs = fromEvent(input, 'keyup')
      .pipe (

      // Project the text from the input
      map(e => (e.target as HTMLInputElement).value),

      // Only if the text is longer than 2 characters
      filter(text => text.length > 2),

      // Pause for 250ms
      debounceTime(250),

      // Only if the value has changed
      distinctUntilChanged(),

      // Search by input value
      switchMap(searchGeocoding),

      )
      .subscribe(
        successGeocoding,
        errorGeocoding
      );

    const customFormSubmit = () => {
      if(inputLat.value !== '' && inputLng.value !== '') {
        $results.hide().empty();
        userPosition = {
          latitude: inputLat.value,
          longitude: inputLng.value,
        };
        // formPositionSubmitted is cleared in list-cirfa.ts after getting userPosition
        sessionStorage.setItem('formPositionSubmitted', input.value);
        // userPosition is cleared in list-cirfa.ts if formPositionSubmitted is not receive
        sessionStorage.setItem('userPosition', JSON.stringify(userPosition));
        // submit true form (not in ajax)
        buttonSubmit.setAttribute('disabled', 'disabled');
        input.setAttribute('disabled', 'disabled');
        customForm.classList.add('isLoading');
        if ("geolocation" in navigator) {
          buttonLocate.setAttribute('disabled', 'disabled');
        }
        trueForm.submit();
      } else if(input.value !== '') {
        $results.find(`.${opt.cssClassDefault}-dropdown-item--error`).remove();
        $results.prepend($('<li>')
          .addClass(`${opt.cssClassDefault}-dropdown-item ${opt.cssClassDefault}-dropdown-item--error`)
          .text(opt.labels.choose_one)
        ).show();
      }
    };

    customForm.addEventListener('submit', (event)=>{
      event.stopPropagation();
      event.preventDefault();
      customFormSubmit();
    });

    // reverse geo coding
    if ("geolocation" in navigator) {
      // geolocation is possible

      buttonLocate= document.createElement('button');
      buttonLocate.classList.add(`${opt.cssClassDefault}-locate`);
      buttonLocate.setAttribute('type', 'button');
      buttonLocate.innerHTML = `<span>${opt.labels.locate}</span>`;
      customFormWrapper.appendChild(buttonLocate);

      const ajaxLoaderLocate= document.createElement('strong');
      ajaxLoaderLocate.classList.add('AjaxLoader');
      buttonLocate.appendChild(ajaxLoaderLocate);

      const locateMsgError= document.createElement('p');
      locateMsgError.classList.add(`${opt.cssClassDefault}-locateMsg`);
      locateMsgError.style.display = 'none';
      locateMsgError.innerHTML = opt.labels.locate_permission_denied;
      customFormWrapper.appendChild(locateMsgError);

      buttonLocate.addEventListener('click', ()=> {
        buttonSubmit.setAttribute('disabled', 'disabled');
        input.setAttribute('disabled', 'disabled');
        buttonLocate.setAttribute('disabled', 'disabled');
        buttonLocate.classList.add('isLoading');
        navigator.geolocation.getCurrentPosition(successLocation,
          errorLocation,
          {
            maximumAge: Infinity,
            timeout:5000,
            enableHighAccuracy: true,
          }
        );
      });

      function alwaysLocation() {
        buttonSubmit.removeAttribute('disabled');
        input.removeAttribute('disabled');
        buttonLocate.removeAttribute('disabled');
        buttonLocate.classList.remove('isLoading');
      }

      function successLocation(position:any) {
        locateMsgError.style.display = 'none';
        $.ajax({
          url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${position.coords.longitude},${position.coords.latitude}.json?secure`,
          method: 'GET',
          data: {
            access_token: MAPBOX_ACCESS_TOKEN,
          },
        })
          .done((datas, _status, _jqXHR) => {
            inputLat.value = position.coords.latitude;
            inputLng.value = position.coords.longitude;
            input.value = datas.features[0].place_name;
            inputSearchAddress.value = datas.features[0].place_name;
            // reset results if we do a reverse geocoding
            $results.hide().empty();
            customFormSubmit();
          })
          .fail((_jqXHR, _status, error) => {
            locateMsgError.innerText = error;
            locateMsgError.style.display = 'block';
          })
          .always((_jqXHR, _status, _error) => {
            setTimeout(()=>{
              alwaysLocation();
            },500);
          });
      }

      function errorLocation(error:any) {
        alwaysLocation();
        locateMsgError.style.display = 'block';
        switch(error.code) {
          case error.PERMISSION_DENIED:
            locateMsgError.innerText = opt.labels.locate_permission_denied;
            break;

          case error.POSITION_UNAVAILABLE:
            locateMsgError.innerText = opt.labels.locate_position_unavailable;
            break;

          case error.TIMEOUT:
            locateMsgError.innerText = opt.labels.locate_timeout;
            break;

          default:
            locateMsgError.innerText = opt.labels.unknown_error;
            break;
        }
      }
    } else {
      // geolocation is not possible
      // we don't display the button
    }
  }
};

export default formPosition;
